import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { PaginatedResponse, Product } from '~shared/models';
import { queryBuilder } from '@metromarkets/sdk';
import {
  API_LAST_DEALS_PRODUCTS_LIST,
  BEST_SELLING_PRODUCTS_LIMIT,
  BEST_SELLING_PRODUCTS_OFFSET
} from '~app/modules/custom-hub/constants';
import { HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { SearchHttpService } from '~app/modules/generic/services/search-http.service';

@Injectable({
  providedIn: 'root'
})
export class LastDealsProductsService {

  constructor(private searchHttpService: SearchHttpService) {}

  getProducts(categoriesSlugs: string[]): Observable<Product[]> {
    const params = queryBuilder.toParams({
      filter: {
        promotion: true,
        categories: categoriesSlugs
      },
      limit: BEST_SELLING_PRODUCTS_LIMIT,
      offset: BEST_SELLING_PRODUCTS_OFFSET,
    }) as HttpParams;

    return this.searchHttpService.getPaginatedProducts(API_LAST_DEALS_PRODUCTS_LIST(), params, 'angular_last_deals_products').pipe(
      map((response: PaginatedResponse<Product>) => response.items.map(item => Product.map(item)))
    );
  }
}
